

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <principal></principal>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import principal from '@/components/principal/Principal.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    principal
    
  },

  methods: {

}

}
    

</script>


